import { Route, Routes } from "react-router-dom";
import LearnLayout from "../layouts/LearnLayout";
import LearnHome from "../pages/learn/LearnHome";
import LearnDispatcher from "../pages/learn/LearnDispatcher";

export function LearnRoutes() {
  return (
    <Routes>
      <Route element={<LearnLayout />}>
        <Route index element={<LearnHome />} /> // /learn
      </Route>
      <Route element={<LearnLayout />}>
        <Route path=":slug1" element={<LearnDispatcher />} />
        <Route path=":slug1/:slug2" element={<LearnDispatcher />} />
        <Route path=":slug1/:slug2/:slug3" element={<LearnDispatcher />} />
        <Route
          path=":slug1/:slug2/:slug3/:slug4"
          element={<LearnDispatcher />}
        />
      </Route>
    </Routes>
  );
}
